(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["desktop-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ulike-menu-products')) {
    customElements.define('ulike-menu-products', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const list = this.querySelector('.ulike-mega-range__products');
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        if (!previous || !next) return;
        const update = () => {
          previous.disabled = list.scrollLeft <= 1;
          next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
        };
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => list.scrollBy({left: Number(button.dataset.direction) * (list.clientWidth + 20), behavior: 'smooth'})));
        list.addEventListener('scroll', update, {passive: true});
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(list);
        update();
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mobile-product-range-toggle]').forEach((button) => {
    if (button.dataset.transitionReady === 'true') return;
    const range = button.closest('.ulike-mobile-product-range');
    const products = range && range.querySelector('[data-mobile-product-range-products]');
    if (!products) return;

    button.dataset.transitionReady = 'true';

    const updateExpandedHeight = () => {
      if (button.getAttribute('aria-expanded') === 'true' && products.scrollHeight > 0) {
        products.style.maxHeight = `${products.scrollHeight}px`;
      }
    };

    updateExpandedHeight();
    window.addEventListener('resize', updateExpandedHeight);

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');

      if (expanded) {
        products.style.maxHeight = `${products.scrollHeight}px`;
        requestAnimationFrame(() => {
          products.style.maxHeight = '0px';
          products.removeAttribute('data-open');
          products.setAttribute('inert', '');
        });
      } else {
        products.removeAttribute('inert');
        products.setAttribute('data-open', 'true');
        products.style.maxHeight = `${products.scrollHeight}px`;
      }
    });
  });

  document.addEventListener('variant:added', (event) => {
    const menu = event.target.closest('.ulike-mobile-navigation');
    if (menu) menu.open = false;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ulike-article-sidebar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ulike-article-sidebar')) {
    customElements.define('ulike-article-sidebar', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const button = this.querySelector('[data-copy]');
        const status = this.querySelector('[role="status"]');
        if (!button || !status) return;
        button.hidden = false;
        button.addEventListener('click', async () => {
          button.disabled = true;
          try {
            await navigator.clipboard.writeText(button.dataset.copy);
            status.textContent = status.dataset.success;
          } catch {
            status.textContent = status.dataset.failure;
          } finally {
            button.disabled = false;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ulike-installment-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ulike-installment-options')) {
    customElements.define('ulike-installment-options', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('details').addEventListener('toggle', () => {
          if (this.querySelector('details').open) {
            this.renderAffirm();
            this.renderMessage();
          }
        });
      }
      async renderAffirm() {
        const message = this.querySelector('.affirm-as-low-as');
        if (!message || this.affirmRendered) return;
        try {
          if (!window.affirm) {
            if (!window.ulikeAffirmLoading) {
              window._affirm_config = {
                public_api_key: '7EVIGVHFF16FT2UN',
                script: 'https://cdn1.affirm.com/js/v2/affirm.js',
                locale: 'en_US',
                country_code: 'USA'
              };
              window.ulikeAffirmLoading = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = window._affirm_config.script;
                script.onload = resolve;
                script.onerror = () => {
                  script.remove();
                  window.ulikeAffirmLoading = null;
                  reject(new Error('Affirm messaging unavailable'));
                };
                document.head.appendChild(script);
              });
            }
            await window.ulikeAffirmLoading;
          }
          if (!this.isConnected) return;
          window.affirm.ui.ready(() => window.affirm.ui.refresh());
          this.affirmRendered = true;
        } catch (error) {
          this.affirmRendered = false;
        }
      }
      async renderMessage() {
        const message = this.querySelector('[data-pp-message]');
        if (!message || this.rendered) return;
        try {
          if (!window.PayPalSDK?.Messages) {
            if (!window.ulikePayLaterLoading) {
              window.ulikePayLaterLoading = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://www.paypal.com/sdk/js?client-id=Afty5nSOYgc0LBjCfAcJmo6mrAE78dSWJajMl1BMn8XlV5weH71oHuiXAM0eCTRELhUfhruDPdKmi7cU&components=messages';
                script.dataset.namespace = 'PayPalSDK';
                script.onload = resolve;
                script.onerror = () => { script.remove(); window.ulikePayLaterLoading = null; reject(new Error('Payment messaging unavailable')); };
                document.head.appendChild(script);
              });
            }
            await window.ulikePayLaterLoading;
          }
          if (!this.isConnected) return;
          await window.PayPalSDK.Messages().render(message);
          this.rendered = true;
        } catch (error) {
          this.rendered = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
